import { StreamMessage, StreamMessageType } from '@nirvana/shared/dtos/types/shared/communication';

export namespace ServiceMessageFromBrowser {
  export interface StreamStart extends StreamMessage.Message {
    type: StreamMessageType.STREAM_START;
    streamStart: StreamMessage.StreamStart['streamStart'] & {
      parameters: { endpointId: string; authCode: string; sessionId: string; size?: { cols: number; rows: number } };
    };
  }

  export interface Data extends StreamMessage.Message {
    type: 'data';
    data: {
      encodedBuffer: string;
    };
  }

  export interface Resize extends StreamMessage.Message {
    type: 'resize';
    resize: {
      cols: number;
      rows: number;
    };
  }
}

export namespace ServiceMessageToBrowser {
  export interface Data {
    id: string;
    type: 'data';
    data: {
      message: string;
    };
  }
}

export namespace ServiceMessageFromEndpoint {
  export const TYPE = {
    DOWNLOAD_FINISHED: 'remoteAccessDownloadFinished',
    UPLOAD_FINISHED: 'remoteAccessUploadFinished',
  };

  export interface Data {
    id: string;
    type: 'data';
    data: {
      encodedBuffer: string;
    };
  }

  export interface Resize {
    id: string;
    type: 'resize';
    resize: {
      cols: number;
      rows: number;
    };
  }

  export interface DownloadFinished {
    id: string;
    type: 'remoteAccessDownloadFinished';
    remoteAccessDownloadFinished?: {
      items: Array<{
        sourceUri: string;
        to: string;
        error: string;
        errorCode: number;
      }>;
      status: string;
    };
  }

  export interface UploadFinished {
    id: string;
    type: 'remoteAccessUploadFinished';
    remoteAccessUploadFinished: {
      items: Array<{
        pattern: string;
        errorCode: number;
      }>;
      status: string;
      centralizedStorage: {
        httpResponse: {
          body: {
            files: Array<{
              id: string;
              url: string;
            }>;
          };
        };
      };
    };
  }
}

export namespace ServiceMessageToEndpoint {
  export interface StreamStartParameters {
    streamId: string;
    size: { cols: number; rows: number };
    inactivityTimeout: number;
  }
}
